<template>
  <div>
    <div v-if="!loadingClaim">
      <b-col class="pa-4" style="justify-content: center" cols="12" md="12">
        <div class="expande-horizontal centraliza-horizontal">
          <div
            v-if="step === 1"
            class="container-rel shaddows"
            style="
              width: 550px;
              display: flex;
              flex-wrap: wrap;
              background: #fff;
              min-height: 30vh;
            "
          >
            <b-col class="mb-4" cols="12" md="12" data-anima="top">
              <h4 class="mb-3 green--text">Acompanhe sua reclamação</h4>
              <span
                class="grey--text"
                style="margin-top: 22px; padding-bottom: 12px"
                >Fique por dentro das atualizações do seu problema</span
              >
            </b-col>
            <b-col cols="12" md="12" data-anima="top">
              <b-form-group
                label="Número da reclamação"
                label-for="numero_reclamacao"
              >
                <b-form-input
                  id="numero_reclamacao"
                  v-model="get_claim_info.id"
                  v-validate="'required'"
                  name="numero_reclamacao"
                  placeholder="Preencha o campo"
                  type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                  :state="submit ? !errors.has('numero_reclamacao') : null"
                >
                  Por favor, informe o ID da sua compra.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col class="mt-2" cols="12" md="12" data-anima="top">
              <b-form-group label="ID da compra" label-for="id_compra">
                <b-form-input
                  id="id_compra"
                  v-model="get_claim_info.sale_id"
                  v-validate="'required'"
                  name="id_compra"
                  placeholder="Insira o ID da compra"
                  type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                  :state="submit ? !errors.has('id_compra') : null"
                >
                  Por favor, informe o ID da compra.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col class="mt-2" cols="12" md="12" data-anima="top">
              <b-form-group label="CPF do cliente" label-for="cpf_cliente">
                <b-form-input
                  id="cpf_cliente"
                  :value="get_claim_info.cpf_cnpj"
                  @input.native="onDocumentInput"
                  v-validate="'required'"
                  name="cpf_cliente"
                  placeholder="Preencha com o seu cpf"
                  type="text"
                  maxlength="18"
                ></b-form-input>
                <b-form-invalid-feedback
                  :state="submit ? !errors.has('cpf_cliente') : null"
                >
                  Por favor, informe o CPF do cliente.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12" class="mt-4 px-3">
              <div class="expande-horizontal column centraliza-vertical">
                <!-- <div style="width: 400px;">
                        <b-tooltip
                            style="width: 100px;"
                            target="span-privacidade"
                            title="Fique tranquilo, apenas o Greenn e o vendedor podem ver os dados informados. Nada que você preencher é público."
                            placement="top"
                        />
                        <div class="expande-horizontal centraliza-vertical">
                            <img class="mr-2" style="height: 15px;" src="../../assets/images/eye-off-blue.svg" />
                            <span class="grey--text" id="span-privacidade">
                                informações privadas
                            </span>
                        </div>
                    </div> -->
                <b-button
                  v-if="!loading"
                  style="width: 100%"
                  :disabled="!canNext"
                  variant="primary"
                  @click="fetch_claim_public"
                >
                  Consultar reclamação
                </b-button>
                <b-button v-else style="width: 100%" variant="primary">
                  <b-spinner style="color: #fff"></b-spinner>
                </b-button>
              </div>
            </b-col>
          </div>
        </div>
        <div v-if="step === 2" class="expande-horizontal wrap">
          <b-col cols="12" md="12">
            <b-row>
              <b-col data-anima="top" cols="12" md="10">
                <h3 style="font-weight: 600" class="text-uppercase"
                  >{{ get_claim.subjective }}
                  <a href="#" class="link-reclamacao" @click.prevent="copyLink"
                    >Copiar link da reclamação</a
                  ></h3
                >
                <div class="expande-horizontal">
                  <div style="display: flex; flex-wrap: no-wrap">
                    <img
                      style="
                        width: 17px;
                        height: 24px;
                        padding-bottom: 3px;
                        margin-right: 6px;
                      "
                      src="../../assets/images/calendario-black.svg"
                    />
                    <span class="grey--text">
                      {{
                        moment(get_claim.created_at).format(
                          'DD/MM/YYYY [às] HH:mm'
                        )
                      }}
                    </span>
                    <strong class="ml-3 mr-1">ID: </strong>
                    <span class="grey--text"> {{ get_claim.id }} </span>
                    <strong v-if="get_claim.closed_date" class="ml-3 mr-1"
                      >Data de encerramento:
                    </strong>
                    <span v-if="get_claim.closed_date" class="grey--text">
                      {{
                        moment(get_claim.closed_date).format(
                          'DD/MM/YYYY [às] HH:mm'
                        )
                      }}
                    </span>
                  </div>
                </div>
              </b-col>
              <b-col cols="12" md="2">
                <b-button
                  v-if="!get_claim.status"
                  class="centered"
                  variant="dark"
                >
                  Aguardando tratativa
                </b-button>
                <b-button
                  v-if="get_claim.status === 'close_solicitation'"
                  class="centered"
                  variant="warning"
                >
                  Aguardando Encerramento
                </b-button>
                <b-button
                  v-if="get_claim.status === 'close'"
                  class="centered"
                  variant="primary"
                >
                  Caso Resolvido
                </b-button>
                <b-button
                  v-if="get_claim.status === 'refund_pending'"
                  class="centered"
                  variant="primary"
                >
                  Aguardando Reembolso
                </b-button>
                <b-button
                  v-if="get_claim.status === 'refunded'"
                  class="centered"
                  variant="primary"
                >
                  Caso Reembolsado
                </b-button>
                <b-button
                  v-if="get_claim.status === 'refunded_automatically'"
                  class="centered"
                  variant="primary"
                >
                  Reembolso automático
                </b-button>
                <!-- <img v-if="!get_claim.status" class="pointer" src="../../assets/images/frown.svg" />
                    <img v-if="get_claim.status === 'close_solicitation'" class="pointer" src="../../assets/images/meh.svg" />
                    <img v-if="get_claim.status === 'close'" class="pointer" src="../../assets/images/smile.svg" />
                    <img v-if="get_claim.status === 'refunded'" class="pointer" src="../../assets/images/smile.svg" /> -->
              </b-col>
              <b-col
                v-if="!isClaimFinalized"
                cols="12"
                md="12"
                class="d-flex flex-wrap align-items-start"
                style="padding-left: 27px; padding-top: 8px;"
              >
                <span
                  v-if="get_claim.progress_status"
                  class="progress-status-badge mr-2 mb-2"
                  :class="getProgressStatusVariant(get_claim.progress_status)"
                >
                  {{ getProgressStatusLabel(get_claim.progress_status) }}
                </span>
                <span v-if="isClaimOverdue" class="progress-status-badge progress-status-danger mb-2">
                  Vencida
                </span>
                <span v-else-if="!isClaimFinalized" class="progress-status-badge progress-status-ok mb-2">
                  3DU
                </span>
              </b-col>
              <b-row>
                <b-col
                  v-if="get_claim.seller_contact"
                  cols="12"
                  md="6"
                  class="mt-2"
                >
                  <div
                    style="
                      display: flex;
                      padding: 15px;
                      margin-top: 10px;
                      flex-direction: column;
                      border: 1px solid #f2f2f2;
                      border-radius: 6px;
                      max-width: 300px;
                    "
                  >
                    <span class="grey--text">Dados do vendedor:</span>
                    <div>
                      <span class="grey--text">
                        Email: {{ get_claim.seller_contact.email }}
                      </span>
                    </div>
                    <div>
                      <span class="grey--text">
                        Telefone: {{ get_claim.seller_contact.telephone }}
                      </span>
                    </div>
                  </div>
                </b-col>
                <b-col
                  v-if="get_claim.seller_contact"
                  cols="12"
                  md="6"
                  class="mt-2"
                >
                  <div
                    style="
                      display: flex;
                      padding: 15px;
                      margin-top: 10px;
                      flex-direction: column;
                      border: 1px solid #f2f2f2;
                      border-radius: 6px;
                      max-width: 300px;
                    "
                  >
                    <span class="grey--text">Dados do Cliente:</span>
                    <div>
                      <span class="grey--text">
                        Email: {{ get_claim.client.email }}
                      </span>
                    </div>
                    <div>
                      <span class="grey--text">
                        Telefone: {{ get_claim.client.cellphone }}
                      </span>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <br />
              <b-row class="mt-3">
                <b-col cols="12" md="12" style="padding-left: 27px">
                  <span
                    style="
                      font-weight: 500;
                      color: #2133d2;
                      background: rgba(33, 51, 210, 0.1);
                      border-radius: 10px;
                      padding-top: 7px;
                      padding-bottom: 7px;
                      padding-right: 11px;
                      padding-left: 11px;
                    "
                    >{{ getCategory(get_claim.objective) }}</span
                  >
                </b-col>
              </b-row>
              <b-col cols="12" md="12">
                <p class="grey--text pa-5 mt-5">{{ get_claim.description }}</p>
              </b-col>
            </b-row>

            <b-row class="mt-5">
              <b-col
                cols="12"
                md="8"
                data-anima="top"
                v-if="!attendance && !success"
              >
                <b-form-textarea
                  id="id_compra"
                  v-model="answer"
                  v-validate="'required'"
                  maxlength="400"
                  name="id_compra"
                  style="min-height: 100px"
                  placeholder="Escreva seu comentário..."
                  type="text"
                ></b-form-textarea>
                <span style="color: grey; font-size: 11px; margin-left: 21px">
                  {{ answer.length }} / 400</span
                >
              </b-col>
              <b-col
                cols="12"
                md="1"
                data-anima="top"
                v-if="!attendance && !success"
              >
                <label for="file-upload" class="custom-file-upload">
                  <img
                    style="position: relative"
                    class="pointer"
                    src="../../assets/images/paperclip.svg"
                  />
                </label>
                <input
                  id="file-upload"
                  accept="image/png,image/jpeg,image/jpg,application/pdf"
                  type="file"
                  @change="setFileToClaim"
                />
              </b-col>
              <b-col
                cols="12"
                md="3"
                data-anima="top"
                v-if="!attendance && !success"
              >
                <b-button
                  v-if="!loading"
                  id="comment-claim-button"
                  v-b-tooltip
                  :title="tooltipMessage"
                  :disabled="!canAnswerClaims || !answer.length"
                  style="
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 45px;
                    display: flex;
                    border: none;
                    font-weight: 500;
                    color: #2133d2;
                    background: rgba(33, 51, 210, 0.1);
                    border-radius: 5px;
                    padding-top: 7px;
                    padding-bottom: 7px;
                    padding-right: 11px;
                    padding-left: 11px;
                  "
                  @click="canAnswerClaims && answer.length ? answer_claim() : null"
                >
                  <span class="blue--text">Comentar</span>
                </b-button>
                <b-button
                  v-else
                  style="
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 45px;
                    display: flex;
                    border: none;
                    font-weight: 500;
                    color: #2133d2;
                    background: rgba(33, 51, 210, 0.1);
                    border-radius: 5px;
                    padding-top: 7px;
                    padding-bottom: 7px;
                    padding-right: 11px;
                    padding-left: 11px;
                  "
                >
                  <b-spinner style="color: #fff"></b-spinner>
                </b-button>
              </b-col>
              <b-col cols="12" md="12" data-anima="top">
                <b-row class="expande-horizontal">
                  <b-col
                    cols="12"
                    md="12"
                    data-anima="top"
                    class="pl-3"
                    v-if="!attendance && !success"
                  >
                    <b-button
                      v-if="get_claim.status !== 'close' && canCloseClaims"
                      data-anima="bottom"
                      class="blue--text small--text btn-clean strong--text"
                      @click="close_claim_admin"
                      >Encerrar o caso Apenas</b-button
                    >
                    <b-spinner
                      v-if="personalizedLoading === 'encerramento-sim'"
                      class="green--text"
                      small
                    ></b-spinner>
                  </b-col>
                  <b-col
                    v-if="get_claim.status === 'refund_pending'"
                    cols="12"
                    md="12"
                    data-anima="top"
                    class="pl-3"
                  >
                    <b-button
                      v-if="get_claim.status === 'refund_pending'"
                      data-anima="top"
                      style="border: solid"
                      class="green--text medium--text btn-clean mt-2"
                      @click="$router.push('/reembolsos')"
                      >O vendedor solicitou o reembolso</b-button
                    >
                    <!-- <button v-if="get_claim.status === 'refund_pending'" data-anima="top" class="green--text small--text btn-clean" @click="personalizedLoading = 'reembolso'">O vendedor solicitou o reembolso, clique para ir para o menu de Reembolsos</button> -->
                    <!-- <button v-if="personalizedLoading === 'reembolso'" data-anima="bottom" class="green--text small--text btn-clean mr-2 strong--text" @click="accept_refund_claim_admin">Aceitar</button>
                    <button v-if="personalizedLoading === 'reembolso'" data-anima="bottom" class="red--text small--text btn-clean mr-2 strong--text" @click="deny_refund_claim_admin">Recusar</button>
                    <b-spinner v-if="personalizedLoading === 'reembolso-sim'" class="green--text" small></b-spinner> -->
                  </b-col>
                  <b-row
                    v-if="!get_claim.status"
                    style="margin: 10px; margin-left: 3px; color: grey"
                  >
                    <b-col> Não há solicitações para aprovar </b-col>
                  </b-row>
                </b-row>
              </b-col>
            </b-row>

            <b-row
              class="expande-horizontal mt-4 mb-4 pr-3"
              style="justify-content: space-between"
            >
              <span class="grey--text mr-3 ml-3 mt-5"
                >Última ação da reclamação</span
              >
              <span
                style="
                  position: relative;
                  right: 0px;
                  cursor: pointer;
                  color: #2133d2;
                  font-weight: 600;
                "
                class="mt-5"
                @click="toggleShowOnlyFirstAnswer"
              >
                Histórico completo
              </span>
            </b-row>

            <b-row class="pl-1 mt-3 expande-horizontal">
              <b-col
                cols="12"
                class="text-md-right"
                v-if="!attendance && !success"
              >
                <b-button
                  :variant="get_claim.is_tagged === 1 ? 'danger' : 'dark'"
                  :disabled="!canTagClaim"
                  v-b-tooltip
                  :title="!canTagClaim ? 'Você não possui permissão para adicionar tags' : ''"
                  @click="$emit('tagClaim', get_claim)"
                >
                  <i class="fas fa-tag"></i>
                </b-button>
                <b-button
                  v-if="
                    get_claim.status !== 'close' &&
                    get_claim.type === 'refund' &&
                    get_claim.status !== 'refund_pending' &&
                    get_claim.status !== 'refunded' &&
                    get_claim.status !== 'refunded_automatically'
                  "
                  class="ml-2"
                  variant="dark"
                  :disabled="!canRefundClaim"
                  v-b-tooltip
                  :title="!canRefundClaim ? 'Você não possui permissão para solicitar reembolso' : ''"
                  @click="$emit('refundClaim', get_claim)"
                >
                  <i class="fas fa-wallet"></i>
                </b-button>
              </b-col>
              <b-col v-if="showOnlyFirstAnswer && get_answers.length" cols="12">
                <div class="timeline">
                  <div
                    class="container-timeline right"
                    :class="getClassByResponse(get_answers[0])"
                  >
                    <div class="content">
                      <div
                        class="expande-horizontal pb-4 pr-3"
                        style="width: 100%; justify-content: space-between"
                      >
                        <strong
                          v-if="get_answers[0].type === 'CLIENT'"
                          class="mr-3 ml-3"
                          >Resposta do Cliente -
                          {{
                            get_answers[0].client
                              ? get_answers[0].client.name
                              : ''
                          }}</strong
                        >
                        <strong
                          v-if="get_answers[0].type === 'SELLER'"
                          class="mr-3 ml-3"
                          >Resposta do Vendedor -
                          {{
                            get_answers[0].user ? get_answers[0].user.name : ''
                          }}</strong
                        >
                        <strong
                          v-if="get_answers[0].type === 'GREENN'"
                          class="mr-3 ml-3"
                          >Resposta do greenn -
                          {{
                            get_answers[0].user ? get_answers[0].user.name : ''
                          }}</strong
                        >
                        <span
                          style="
                            position: relative;
                            right: 0px;
                            cursor: pointer;
                          "
                          class="mt-5 grey--text"
                        >
                          {{
                            moment(get_answers[0].created_at).format(
                              'DD/MM/YYYY [às] HH:mm'
                            )
                          }}
                        </span>
                      </div>
                      <div class="expande-horizontal pb-4 ml-3">
                        <p
                          class="grey--text"
                          style="padding: 0px; margin: 0px; top: -5px"
                          >{{ get_answers[0].answer }}</p
                        >
                      </div>
                      <div class="expande-horizontal pb-4 ml-3">
                        <a
                          v-for="(att, index) in get_answers[0]
                            .attachment_answers"
                          :key="att.id"
                          class="link-arquive"
                          :href="att.attachment"
                          target="_blank"
                          style="
                            display: flex;
                            min-width: 200px;
                            width: 200px;
                            align-items: center;
                          "
                          @click="openFile(att.attachment)"
                        >
                          <div class="link-arquive-dot-blue"></div> Arquivo{{
                            index + 1
                          }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
              <b-col
                v-if="!showOnlyFirstAnswer && get_answers.length"
                cols="12"
              >
                <div
                  v-for="item in get_answers"
                  :key="item.id"
                  class="timeline"
                >
                  <div
                    class="container-timeline right"
                    :class="getClassByResponse(item)"
                  >
                    <div class="content">
                      <div
                        class="expande-horizontal pb-4 pr-3"
                        style="width: 100%; justify-content: space-between"
                      >
                        <strong
                          v-if="item.type && item.type === 'CLIENT'"
                          style="position: relative; top: -4px"
                          class="mr-3 ml-3"
                          >Resposta do Cliente -
                          {{ item.client ? item.client.name : '' }}</strong
                        >
                        <strong
                          v-if="item.type && item.type === 'SELLER'"
                          style="position: relative; top: -4px"
                          class="mr-3 ml-3"
                          >Resposta do Vendedor -
                          {{ item.user ? item.user.name : '' }}</strong
                        >
                        <strong
                          v-if="item.type && item.type === 'GREENN'"
                          style="position: relative; top: -4px"
                          class="mr-3 ml-3"
                          >Resposta do greenn -
                          {{ item.user ? item.user.name : '' }}</strong
                        >
                        <span
                          style="
                            position: relative;
                            right: 0px;
                            cursor: pointer;
                          "
                          class="grey--text"
                        >
                          {{
                            moment(item.created_at).format(
                              'DD/MM/YYYY [às] HH:mm'
                            )
                          }}
                        </span>
                      </div>
                      <div class="expande-horizontal pb-4 ml-3">
                        <p class="grey--text">{{ item.answer }}</p>
                      </div>
                      <div class="expande-horizontal pb-4 ml-3">
                        <a
                          v-for="(att, index) in item.attachment_answers"
                          :key="att.id"
                          class="link-arquive"
                          :href="att.attachment"
                          target="_blank"
                          style="
                            display: flex;
                            min-width: 200px;
                            width: 200px;
                            align-items: center;
                          "
                        >
                          <div class="link-arquive-dot-blue"></div> Arquivo{{
                            index + 1
                          }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </div>
      </b-col>
    </div>
    <div v-if="loadingClaim" class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import validAcessRoute from '@/src/utils/validAcessRoute'
import Claim from '../../services/resources/ClaimService'
import Erp from '../../services/resources/ErpService'
import Null from '../../services/resources/NullService'
import Vue from 'vue'
import { onDocumentInput as handleDocumentInput } from '@src/helpers/documentValidator'

const serviceAdmin = Claim.build()
const serviceErp = Erp.build()
const serviceNull = Null.build()

const PROGRESS_STATUS_MAP = {
  AWAITING_3DU: { label: 'Aguardando 3DU', variant: 'progress-status-primary' },
  OUT_OF_WARRANTY: { label: 'Fora do prazo de garantia', variant: 'progress-status-warning' },
  IN_PROGRESS: { label: 'Em tratativa', variant: 'progress-status-info' },
  AUTO_CLOSED: { label: 'Encerrada automaticamente', variant: 'progress-status-secondary' },
  CLOSED: { label: 'Encerrada', variant: 'progress-status-dark' },
}

export default {
  data() {
    return {
      loadingClaim: false,
      success: validAcessRoute(['success'], this.$store.getters.getProfile),
      attendance: validAcessRoute(
        ['attendance'],
        this.$store.getters.getProfile
      ),
      moment: moment,
      step: this.$route.path === '/' ? 1 : 2,
      showOnlyFirstAnswer: true,
      submit: false,
      answer: '',
      answerFile: '',
      get_claim: {},
      get_claim_info: {
        id: '',
        sale_id: '',
        cpf_cnpj: '',
      },
      get_answers: [],
      loading: false,
      personalizedLoading: '',
      client: {},
    }
  },
  props: {
    dados: {
      type: Object,
      default: () => {},
    },
    canTagClaim: {
      type: Boolean,
      default: true,
    },
    canRefundClaim: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    tooltipMessage() {
      if (this.canAnswerClaims && !this.answer.length) {
        return 'Digite um comentário para habilitar o botão.';
      }

      if (!this.canAnswerClaims) {
        return 'Você não possui permissão de editor para responder esta reclamação.';
      }

      return '';
    },
    canNext() {
      if (
        this.get_claim_info.cpf_cnpj &&
        this.get_claim_info.sale_id &&
        this.get_claim_info.id
      ) {
        return true
      }
      return false
    },
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    },
    canAnswerClaims() {
      return this.$canAction('claims_answer_button', 'editor')
    },
    canCloseClaims() {
      return this.$canAction('claims_close_button', 'editor')
    },
    isClaimOverdue() {
      return !!this.get_claim.deadline_passed || !!this.get_claim.overdue
    },
    isClaimFinalized() {
      return (
        ['close', 'refunded', 'refunded_automatically', 'refund_denied'].includes(this.get_claim.status) ||
        ['CLOSED', 'AUTO_CLOSED'].includes(this.get_claim.progress_status)
      )
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.loadingClaim = true
      const dadosGet = {
        s_id: this.dados.s_id || this.$route.query.s_id,
        id: this.dados.id || this.$route.query.id,
        doc: this.dados.doc || this.$route.query.doc,
      }

      serviceAdmin
        .search({
          sale_id: dadosGet.s_id,
          cpf_cnpj: dadosGet.doc,
          id: dadosGet.id,
          url: `/list/${dadosGet.id}`,
        })
        .then((res) => {
          if (!res || !res.claim) {
            this.$bvToast.toast('Não foi possível carregar a reclamação. Tente novamente.', {
              variant: 'warning',
              title: 'Reclamações',
              autoHideDelay: 5000,
            })
            return
          }

          this.fetch_claim_admin(res.claim, res.answers || [], res.claim.client)
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          this.loadingClaim = false
        })
    })
  },
  methods: {
    onDocumentInput(event) {
      handleDocumentInput(event, (value) => {
        this.get_claim_info.cpf_cnpj = value;
      });
    },
    copyLink() {
      const baseUrl =
        (this.isHeaven ? process.env.VUE_APP_HEAVEN_BASE_URL : process.env.VUE_APP_BASE_URL) || 'https://erp.greenn.com.br'

      navigator.clipboard.writeText(
        `${baseUrl}/reclamacao?s_id=${this.dados.s_id}&id=${this.dados.id}&doc=${this.dados.doc}`
      )

      this.$bvToast.toast('Link copiado com sucesso!', {
        variant: 'success',
        title: 'Link reclamação',
        autoHideDelay: 5000,
      })
    },
    openFile(url) {
      window.open(url, '_blank')
    },
    fetch_claim_admin(payload, answers, client) {
      this.get_claim = payload
      this.get_claim_info = payload
      this.get_answers = answers.reverse()
      this.client = client
      this.step = 2
      this.$bvModal.show('modal-view-claim')
    },
    close_claim_admin() {
      Vue.swal({
        title: 'Autorizar Encerramento',
        text: 'Tem certeza que deseja Encerramento a Reclamação?',
        type: 'success',
        showCancelButton: true,
        confirmButtonText: 'Encerrar',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-dark mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.personalizedLoading = 'encerramento-sim'
          serviceNull
            .update(null, `/claim/close/${this.get_claim.id}`)
            .then(() => {
              this.$bvToast.toast('A reclamação foi encerrada', {
                variant: 'success',
                title: 'Fechamento',
                autoHideDelay: 5000,
                // appendToast: true,
              })
              this.get_claim.status = 'close'
              this.$bvModal.hide('modal-view-claim')
              this.personalizedLoading = ''
              this.$emit('list-claim')
            })
            .catch(() => {
              this.personalizedLoading = ''
              this.loading = false
              this.$bvToast.toast('Erro ao encerrar, tente novamente', {
                variant: 'danger',
                title: 'Fechamento',
                autoHideDelay: 5000,
              })
            })
        }
      })
    },
    getCategory(category) {
      let r = ''
      if (category) {
        switch (category.toLowerCase()) {
          case 'DUPLICATE_PURCHASE': {
            r = 'Compra duplicada'
            break
          }
          case 'PRODUCT_NOT_DELIVERED': {
            r = 'O vendedor não entregou o produto'
            break
          }
          case 'EXPECTATIONS_NOT_MEETED': {
            r = 'O produto não atendeu a expectativa'
            break
          }

          case 'GAVE_UP_BUYING': {
            r = 'Desistiu da compra'
            break
          }

          case 'BUY_WRONG': {
            r = 'Comprou errado'
            break
          }

          default: {
            r = category
            break
          }
        }
        return r
      } else return category
    },

    getProgressStatusLabel(progressStatus) {
      const entry = PROGRESS_STATUS_MAP[progressStatus]
      return entry ? entry.label : progressStatus
    },
    getProgressStatusVariant(progressStatus) {
      const entry = PROGRESS_STATUS_MAP[progressStatus]
      return entry ? entry.variant : 'progress-status-secondary'
    },

    accept_refund_claim_admin() {
      this.personalizedLoading = 'reembolso-sim'
      serviceErp
        .update({}, `refund-solicitation/${this.get_claim.id}?status=ACCEPT`)
        .then(() => {
          this.$bvToast.toast('O reembolso foi aceito!', {
            variant: 'success',
            title: 'Reembolso',
            autoHideDelay: 5000,
          })
          this.$bvModal.hide('modal-view-claim')
          this.personalizedLoading = ''
        })
        .catch(() => {
          this.loading = false
          this.$bvToast.toast('Falha ao processar a solicitação. Tente novamente.', {
            variant: 'danger',
            title: 'Reclamações',
            autoHideDelay: 5000,
          })
        })
    },
    deny_refund_claim_admin() {
      this.personalizedLoading = 'reembolso-sim'
      serviceErp
        .update({}, `refund-solicitation/${this.get_claim.id}?status=DENIED`)
        .then(() => {
          this.$bvToast.toast('O reembolso foi negado!', {
            variant: 'warning',
            title: 'Reembolso',
            autoHideDelay: 5000,
            // appendToast: true,
          })
          this.$bvModal.hide('modal-view-claim')
          this.personalizedLoading = ''
        })
        .catch(() => {
          this.loading = false
          this.personalizedLoading = ''
          this.$bvToast.toast('Falha ao processar a solicitação. Tente novamente.', {
            variant: 'danger',
            title: 'Reclamações',
            autoHideDelay: 5000,
          })
        })
    },
    fetch_claim_public() {
      this.loading = true
      serviceAdmin
        .search({
          sale_id: this.get_claim_info.sale_id,
          cpf_cnpj: this.get_claim_info.cpf_cnpj,
          id: this.get_claim_info.id,
          url: `/list/${this.get_claim_info.id}`,
        })
        .then((res) => {
          if (res.claim) {
            this.get_claim = res.claim
            this.get_answers = []
            this.get_answers = res.answers.reverse()
            this.step = 2
          } else {
            this.$bvToast.toast('Verifique os dados e tente novamente', {
              variant: 'warning',
              title: 'Busca',
              autoHideDelay: 5000,
              // appendToast: true,
            })
          }
          this.loading = false
          this.showOnlyFirstAnswer = false
          this.showOnlyFirstAnswer = true
        })
        .catch(() => {
          this.loading = false
          this.$bvToast.toast('Falha ao processar a solicitação. Tente novamente.', {
            variant: 'danger',
            title: 'Reclamações',
            autoHideDelay: 5000,
          })
        })
    },
    answer_claim() {
      this.loading = true
      var formData = new FormData()
      formData.append('answer', this.answer)
      formData.append('attachment', this.answerFile)
      formData.append('claim_id', this.get_claim.id)
      formData.append('type', 'GREENN')
      serviceAdmin
        .create(formData, null, `/answer/${this.get_claim.id}`)
        .then(() => {
          this.answer = ''
          this.answerFile = ''
          this.loading = false
          this.$bvToast.toast('Sua resposta foi enviada com sucesso!', {
            variant: 'success',
            title: 'Envio de resposta',
            autoHideDelay: 5000,
            // appendToast: true,
          })
          this.loading = false
          this.$emit('list-claim')
        })
        .catch(() => {
          this.loading = false
          this.$bvToast.toast('Falha ao processar a solicitação. Tente novamente.', {
            variant: 'danger',
            title: 'Reclamações',
            autoHideDelay: 5000,
          })
        })
        .finally(() => {
          this.answer = ''
          this.answerFile = null
          this.loading = false
          this.fetch_claim_public()
        })
    },
    getClassByResponse(item) {
      const resp = {
        CLIENT: 'color-resp-client',
        SELLER: 'color-resp-seller',
        GREENN: 'color-resp-greenn',
      }
      if (item) {
        return resp[item.type]
      } else {
        return ''
      }
    },
    toggleShowOnlyFirstAnswer() {
      this.showOnlyFirstAnswer = !this.showOnlyFirstAnswer
    },
    uploadImageSuccess(formData, index, fileList) {
      this.answerFile = fileList
    },
    beforeRemove(index, done) {
      var r = confirm('Remover arquivo?')
      if (r == true) {
        done()
        this.answerFile.splice(index, 1)
      }
    },
    setFileToClaim(e) {
      this.answerFile = e.target.files[0]
      this.$bvToast.toast('O arquivo foi carregado com sucesso!', {
        variant: 'success',
        title: 'Arquivo',
        autoHideDelay: 5000,
        appendToast: true,
      })
    },
  },
}
</script>

<style scoped>
input[type='file'] {
  display: none;
}
.custom-file-upload {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  width: 45px;
  background: #f7f7f7;
  border-radius: 5px;
  border: none;
  cursor: pointer;
}
.avatar- {
  min-width: 60px;
  min-height: 60px;
  max-width: 60px;
  max-height: 60px;
  border-radius: 50%;
  margin-right: 30px;
  display: flex;
  background: #37cf79;
  align-items: center;
  justify-content: center;
}
.red--text {
  color: #ff0c37;
}
.small--text {
  font-size: 12px;
}

.medium--text {
  font-size: 12px;
}

.link-arquive {
  background: #f7f7f7;
  padding: 12px;
  border-radius: 5px;
  color: #333333;
  font-size: 14px;
  height: 35px;
  cursor: pointer;
  text-decoration: none;
  padding-bottom: 6px;
}
.link-arquive-dot-blue {
  width: 10px;
  height: 5px;
  border-radius: 5px;
  background: #2133d2;
  position: relative;
  margin-right: 6px;
}
.link-arquive-dot-red {
  width: 10px;
  height: 5px;
  border-radius: 5px;
  background: #ff0c37;
  position: relative;
  margin-right: 6px;
}
.btn-clean {
  border: none;
  background: rgba(0, 0, 0, 0);
}
.strong--text {
  font-weight: bold;
}
.green--text {
  color: #37cf79;
}
.blue--text {
  color: #2133d2;
}
.grey--text {
  color: #81858e;
}
.spacer {
  width: 100%;
}
.button-text-blue {
  background: transparent;
  border: none;
  font-size: 10pt;
  text-align: left;
  font-weight: 700;
}
.box-info {
  border-radius: 6px;
  background: #f5f5f5;
  font-size: 11pt;
  color: #81858e;
  padding: 24px;
}
.shaddows {
  border-radius: 12px;
  box-shadow: 2px 2px 3px 3px #f2f2f2;
}

.timeline {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.timeline::before {
  content: '';
  position: absolute;
  width: 6px;
  background-color: #ededf0;
  top: 0;
  width: 1px;
  bottom: 0;
}

.container-timeline {
  padding-top: -20px;
  padding-left: 20px;
  position: relative;
  background-color: inherit;
}

.container-timeline::after {
  content: '';
  position: absolute;
  width: 10px;
  height: 10px;
  left: 15px;
  top: 0px;
  border-radius: 50%;
  z-index: 1;
}
.color-resp-client::after {
  background-color: #ff0c37;
  box-shadow: 0px 0px 5px #ff0c37;
}
.color-resp-seller::after {
  background: #2133d2;
  box-shadow: 0px 0px 10px #2133d2;
}
.color-resp-greenn::after {
  background: #37cf79;
  box-shadow: 0px 0px 10px #37cf79;
}
.left {
  left: 0;
}
.right::before {
  content: ' ';
  height: 0;
  position: absolute;
  width: 0;
  z-index: 1;
}

.right::after {
  left: -4px;
}

.content {
  background-color: white;
  position: relative;
  top: -5px;
}
.progress-status-badge {
  display: inline-flex;
  align-items: center;
  line-height: 1.2;
  white-space: nowrap;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.progress-status-primary {
  background: rgba(85, 110, 230, 0.12);
  color: #3a4fc7;
}
.progress-status-warning {
  background: rgba(241, 180, 76, 0.15);
  color: #8a5a00;
}
.progress-status-info {
  background: rgba(80, 165, 241, 0.12);
  color: #1f6fae;
}
.progress-status-secondary {
  background: rgba(116, 120, 141, 0.12);
  color: #4b4f5c;
}
.progress-status-dark {
  background: rgba(52, 58, 64, 0.1);
  color: #1f2327;
}
.progress-status-danger {
  background: #e74c3c;
  color: #fff;
}
.progress-status-ok {
  background: #66bb6a;
  color: #fff;
}
.link-reclamacao {
  font-weight: 500 !important;
  font-size: 13px !important;
  text-transform: none;
  margin-left: 20px;
  background: #f7f7f7;
  padding: 8px 16px;
  border-radius: 5px;
  color: #333;
}

@media screen and (max-width: 600px) {
  /* Place the timelime to the left */
  .timeline::after {
    left: 31px;
  }

  .container-timeline {
    width: 100%;
  }

  .container::before {
    left: 60px;
  }

  .right {
    left: 0%;
  }
}
</style>
